import React from "react";

import nextIcon from "../../../../assets/img/greater-icon.svg";
import { HELP_TOPICS } from "../../../../helpers/constants";
import { useHistory } from "react-router-dom";

function HelpBreadCrumbs({
  moduleName,
  screenSize,
  handleClickBack,
  selectedLanguage,
  handleClickNext,
  pagesData,
  showFullDetails = true,
  handleClickTopic,
}) {
  const getTranslatedSectionName = () => {
    if (!showFullDetails) {
      let decodedModuleName = decodeURIComponent(moduleName);
      let selectedSection = pagesData?.filter((item) => item?._id === moduleName || item?.pageName === decodedModuleName)[0];
      //eslint-disable-next-line
      let refactoredData = HELP_TOPICS?.map((item) => {
        if (item?.name === selectedSection?.sectionName || (item?.name === "Registration & Login" && moduleName === "Registration%20&%20Login")) {
          return selectedLanguage === "arabic" ? item?.arabicName : item?.name;
        }
      });
      return refactoredData;
    }
    //eslint-disable-next-line
    let refactoredData = HELP_TOPICS?.map((item) => {
      if (item?.name === moduleName || (item?.name === "Registration & Login" && moduleName === "Registration%20&%20Login")) {
        return selectedLanguage === "arabic" ? item?.arabicName : item?.name;
      }
    });
    return refactoredData;
  };

  const getSectionLink = () => {
    let decodedModuleName = decodeURIComponent(moduleName);

    let selectedSection = pagesData?.find((item) => item?._id === moduleName || item?.pageName === decodedModuleName);

    const foundTopic = HELP_TOPICS?.find((item) => {
      const isStandardMatch = item?.name === selectedSection?.sectionName;
      const isSpecialMatch = item?.name === "Registration & Login" && decodedModuleName === "Registration & Login";
      return isStandardMatch || isSpecialMatch;
    });
    const result = foundTopic?.name || "";

    return result;
  };

  const history = useHistory();
  const goBackToSection = () => {
    if (!showFullDetails) {
      history.push(`help?topic=${getSectionLink()}`);
    }
  };

  return (
    <div style={{ marginTop: "1.5rem", height: "100%", paddingBottom: showFullDetails ? "5rem" : "2rem" }}>
      <div className="d-flex align-items-center" style={{ fontWeight: 500, fontSize: "16px", gap: "1rem" }}>
        <span onClick={handleClickBack} style={{ color: "#2D9CDB" }} className="cursor-pointer">
          {selectedLanguage === "arabic" ? "المساعدة " : "Help"}
        </span>{" "}
        <img src={nextIcon} alt="nextIcon" className={`${selectedLanguage === "arabic" ? "rotate-180" : ""}`} />{" "}
        <span style={{ color: showFullDetails ? "#4F4F4F" : "#2D9CDB", cursor: showFullDetails ? "auto" : "pointer" }} onClick={goBackToSection}>
          {" "}
          {getTranslatedSectionName()}
        </span>
      </div>
      {showFullDetails ? (
        <div style={{ marginTop: "2rem" }} className={`${selectedLanguage === "arabic" ? "rtl" : "ltr"}`}>
          <p style={{ fontSize: screenSize > 600 ? "35px" : "25px", fontWeight: 500, color: "#4F4F4F" }} className="pb-5">
            {getTranslatedSectionName()}
          </p>
          <div className="d-flex flex-column" style={{ gap: "1.5rem", color: "#2D9CDB", fontWeight: 500, fontSize: "16px" }}>
            {pagesData
              ?.filter(
                (item) =>
                  item?.sectionName === moduleName || (item?.sectionName === "Registration & Login" && moduleName === "Registration%20&%20Login"),
              )
              ?.map((item) => {
                return (
                  <div className="cursor-pointer" onClick={() => handleClickNext(item?.pageName)}>
                    {selectedLanguage === "arabic" ? item?.arabicPageName : item?.pageName}
                  </div>
                );
              })}
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default HelpBreadCrumbs;
